module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "lightest px-2 py-1 fs-normal radius-normal",
    class: _vm.bgColor
  }, [_vm._v("\n    " + _vm._s(_vm.getPaymentState(_vm.paymentStateCode).label) + "\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3831a96a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3831a96a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/PaymentStatusBtn.vue
// module id = 1885
// module chunks = 0